module.exports = __webpack_public_path__ + "static/media/brand-oath-sq.0d8fd754.jpg";